// ==================== Importing Team members Images from relative path ==================
import member1 from "assets/images/team/@westreamer.jpeg";
import member2 from "assets/images/team/@projxctmayhem.jpeg";
import member3 from "assets/images/team/@horintt.jpeg";
import member4 from "assets/images/team/@pearldavinci.jpeg";
import member5 from "assets/images/team/@streamfather.jpeg";
import member6 from "assets/images/team/@wizzie08.jpeg";
import member7 from "assets/images/team/@master25o0.jpg";
import member8 from "assets/images/team/@afifchan5.jpeg";
import member9 from "assets/images/team/@schturdy.jpeg";
import member10 from "assets/images/team/@thesapphirecat.jpeg";
import member11 from "assets/images/team/@zarablockchain.jpeg";
import member12 from "assets/images/team/@givusdt.jpg";

const OurTeam = () => {
  // PUT your team members data in this array of object like this name, his role & his image
  const teamData = [
    {
      name: "@westreamer",
      img: member1,
      link: `https://twitter.com/westreamer`,
      role: `Founder`,
    },
    {
      name: "@projxctmayhem",
      img: member2,
      link: `https://twitter.com/projxctmayhem`,
      role: `Co-Founder`,
    },
    {
      name: "@streamfather",
      img: member5,
      link: `https://twitter.com/streamfather`,
      role: `Marketing`,
    },
    {
      name: "@horintt",
      img: member3,
      link: `https://twitter.com/horintt`,
      role: `Artist`,
    },
    {
      name: "@pearldavinci",
      img: member4,
      link: `https://twitter.com/pearldavinci`,
      role: `Social Media`,
    },
    // {
    //   name: "@zdotnft1",
    //   img: member5,
    //   link: `https://twitter.com/zdotnft1`,
    //   role: `Moderator`,
    // },
    // {
    //   name: "@wizzie08",
    //   img: member6,
    //   link: `https://twitter.com/wizzie08`,
    //   role: `Back-End`,
    // },
    // {
    //   name: "@master25o0",
    //   img: member7,
    //   link: `https://twitter.com/master25o0`,
    //   role: `Developer`,
    // },
    // {
    //   name: "@afifchan5",
    //   img: member8,
    //   link: `https://twitter.com/afifchan5`,
    //   role: `Artist`,
    // },
    {
      name: "@schturdy",
      img: member9,
      link: `https://twitter.com/schturdy`,
      role: `Front-End`,
    },
    {
      name: "@thesapphirecat",
      img: member10,
      link: `https://twitter.com/thesapphirecat`,
      role: `Admin`,
    },
    {
      name: "@zarablockchain",
      img: member11,
      link: `https://twitter.com/zarablockchain`,
      role: `Treasurer`,
    },
 
    // {
    //   name: "@givusdt",
    //   img: member12,
    //   link: `https://twitter.com/givusdt`,
    //   role: `Community`,
    // },
  ];
  return (
    <section id="team">
      <div className="container">
        <div className="sec-heading-wrapper">
          {/* =============== Main Heading ============== */}
          <h1 className="sec-heading" data-aos="fade-up">
            Our Team
          </h1>
        </div>
        <div className="team-wrapper row">
          {teamData.map((data, ind) => {
            return (
              <div
                data-aos="fade-up"
                key={ind}
                className="row column team-card"
              >
                <div className="team-card-img">
                <img src={data.img} alt={data.name} />
                </div>
                <div className="member-card-body row column">
                  <a href={data?.link} target="_blank" rel="noopener noreferrer">
                    {data.name}
                  </a>
                  <p className="role-">{data.role}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
